import { Injectable } from '@angular/core'
import { FormGroup, Validators, FormBuilder } from '@angular/forms'
import { MyUtilityService } from '@app/shared/services/my-utility.service'
import { ValidationService } from '@app/shared/services/validation.service'
import { TelephoneApiService } from '@app/modules/telephone/telephone-api.service'
import { TelephoneNameService } from '@app/modules/telephone-name/telephone-name.service'

@Injectable()

export class TelephoneService {

  /**
   * To delete
   *
   * Id's marked for deleting.
   */
  public toDelete: Array<number> = []

  /**
   * Constructor
   */
  public constructor (
    public formBuilder: FormBuilder,
    public myUtil: MyUtilityService,
    public api: TelephoneApiService,
    public telephoneNameService: TelephoneNameService
  ) {}

  /**
   * Get form
   */
  public getForm (telephone?: any | Object): FormGroup {
    const form: FormGroup = this.formBuilder.group({
      uuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      telephoneNameUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      number: [
        null,
        [
          ValidationService.noWhiteSpace,
          ValidationService.noEmojis,
          Validators.maxLength(191)
        ]
      ],
      extension: [
        null,
        [
          ValidationService.noWhiteSpace,
          ValidationService.noEmojis,
          Validators.maxLength(191)
        ]
      ],
      // Info.
      createdAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      updatedAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      deletedAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      createdByUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      updatedByUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ]
    })

    if (!this.myUtil.isEmpty(telephone)) {
      if (Object.keys(telephone).length !== 0) {
        form.patchValue(telephone, { emitEvent: false })
      }
    }

    return form
  }

}
